import React, { useState, useRef, useEffect } from 'react';
import axios from 'axios';
import { API_BASE_URL } from '../Config.js';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Select from 'react-select';
import BillPopup from './BillPopup';
import printJS from "print-js";
import styles from './InterCompanyBilling.module.css';
import PrintBillModal from '../print/PrintBillModal.js';


const InterCompanyTranfer = ({ userData }) => {
  const [selectedItems, setSelectedItems] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [searchResults, setSearchResults] = useState([]);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [customerName, setCustomerName] = useState('');
  const [customerMobileNo, setCustomerMobileNo] = useState('');
  const [paymentMode, setPaymentMode] = useState('Due');
  const [schoolName, setSchoolName] = useState('');
  const [selectedIndex, setSelectedIndex] = useState(-1);
  const [shiftPressTime, setShiftPressTime] = useState(null);
  const [companyId, setSelectedCompanyId] = useState(null);

  const [isBarcodeMode, setIsBarcodeMode] = useState(false);
  const [barcode, setBarcode] = useState('');

  const searchInputRef = useRef(null);
  const barcodeInputRef = useRef(null);
  const dropdownRef = useRef(null);
  const [showPdfModal, setShowPdfModal] = useState(false);
  const [pdfData, setPdfData] = useState(null);
  const pdfModalRef = useRef(null);
  const [showCustomItemModal, setShowCustomItemModal] = useState(false);
  const inputRefs = useRef([]);
  const [isTableFocused, setIsTableFocused] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [someState, setSomeState] = useState(false);
  const [filteredSchools, setFilteredSchools] = useState([]);

  const [suggestions, setSuggestions] = useState([]);
  const [loading, setLoading] = useState(false);

  const [allSchools, setAllSchools] = useState([]);
  const selectedSchoolRef = useRef(null);
  const [storeList, setStoreList] = useState([]);

  const [showPrintModal, setShowPrintModal] = useState(false);
  const [billInfo, setBillInfo] = useState(null);

  // ---- Error Modal state (replaces alert()) ----
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [errorModalTitle, setErrorModalTitle] = useState('Error');
  const [errorModalMessage, setErrorModalMessage] = useState('');
  const [errorModalItems, setErrorModalItems] = useState([]);

  const showError = (message, title = 'Error', items = []) => {
    setErrorModalTitle(title);
    setErrorModalMessage(message);
    setErrorModalItems(items);
    setShowErrorModal(true);
  };

  const closeErrorModal = () => {
    setShowErrorModal(false);
    setErrorModalItems([]);
  };

  const handleDiscountChange = (index, discountValue) => {

    setSelectedItems((prevItems) => {
      const updatedItems = [...prevItems];
      const item = updatedItems[index];
      item.discountAmount = discountValue; // Apply discount amount only if discount is "Yes"
      item.amount = item.wholeSalePrice * (1 - discountValue / 100) * item.quantity;
      return updatedItems;
    });
  };




  const [customItem, setCustomItem] = useState({
    itemBarcodeID: 'SG9999999',
    itemType: '',
    itemColor: '',
    itemSize: '',
    itemCategory: '',
    sellPrice: 0,
    quantity: 1,
    amount: 0,
  });



    const fetchStores = async () => {
      try {
        const user = JSON.parse(sessionStorage.getItem("user"));
        const storeId = user ? user.storeId : '';


        const response = await fetch(`${API_BASE_URL}/store/getStoreList?storeId=${storeId}`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
        });

        if (response.ok) {
          const data = await response.json();
          setStoreList(data); // Set the store list
        } else {
          console.error('Failed to fetch stores.');
          setStoreList([]); // Handle empty or error response
        }
      } catch (error) {
        console.error('Error fetching stores:', error);
        setStoreList([]); // Handle fetch errors
      }
    };



  const fetchAllSchools = async () => {
    try {
        const user = JSON.parse(sessionStorage.getItem('user'));
        const storeId = user?.storeId;
        const response = await axios.get(`${API_BASE_URL}/user/filter/getSchoolNameandCode`, {
            params: {
                storeId: storeId,
            },
        });

        if (Array.isArray(response.data)) {
            const schoolOptions = response.data.map((school) => ({
                value: `${school.schoolName} (${school.schoolCode})`, // Combined for display
                label: `${school.schoolName} (${school.schoolCode})`, // Combined for display
                schoolName: school.schoolName, // Separate property for easy access
                schoolCode: school.schoolCode,
            }));
            setAllSchools(schoolOptions);
        } else {
            console.error('Expected an array of schools, but got:', response.data);
        }
    } catch (error) {
        console.error('Error fetching school names:', error);
    }
};


const handleSelectChange = (selectedOption) => {
  // Set only the school name without the code
  setSchoolName(selectedOption ? selectedOption.schoolName : '');
};

  useEffect(() => {
    fetchAllSchools();
    fetchStores();
  }, []);

    const handleSelectFocus = () => {
      setIsTableFocused(false);
    };

    const handleSelectBlur = () => {
      setIsTableFocused(true);
    }

  useEffect(() => {
    if (searchTerm.trim() !== '') {
      const fetchItems = async () => {
        try {

          const user = JSON.parse(sessionStorage.getItem("user"));
          const storeId = user ? user.storeId : '';

          const response = await axios.get(`${API_BASE_URL}/inventory/getAllItems`, {
            params: {
              searchTerm: searchTerm,
              storeId: storeId,
            }
          });

          setSearchResults(response.data || []); // Set search results or empty array
          setSelectedIndex(-1);
          setDropdownOpen(true);

        } catch (error) {
          console.error('Error fetching items:', error);
          setSearchResults([]);
        }
      };

      fetchItems();
    }
  }, [searchTerm, isBarcodeMode]);



  const handleCustomItemChange = (e) => {
    const { name, value } = e.target;
    setCustomItem((prev) => ({
      ...prev,
      [name]: value,
      amount: name === 'quantity' || name === 'sellPrice'
        ? customItem.sellPrice * customItem.quantity
        : prev.amount,
    }));
  };




  useEffect(() => {
    if (isBarcodeMode && barcode.trim() !== '') {
      const fetchItemByBarcode = async () => {
        try {
          toggleBarcodeMode(true);

          const user = JSON.parse(sessionStorage.getItem('user'));
          const storeId = user?.storeId; // Retrieve storeId from user data

          const response = await axios.get(`${API_BASE_URL}/user/search/item_code`, {
            params: {
              barcode: barcode.trim(),
              storeId: storeId // Include storeId as a query parameter
            }
          });
          if (response.data) {
            addItemToBill(response.data);
          } else {
            console.error('Item not found for barcode:', barcode);
          }
        } catch (error) {
          console.error('Error fetching item by barcode:', error);
        } finally {
          setBarcode(''); // Clear barcode field
          barcodeInputRef.current.focus();
        }
      };
      fetchItemByBarcode();
    }
  }, [barcode, isBarcodeMode]);

  useEffect(() => {
    if (dropdownRef.current && selectedIndex >= 0) {
      const dropdown = dropdownRef.current;
      const items = dropdown.querySelectorAll('tr');
      if (items.length > 0) {
        const item = items[selectedIndex];
        const dropdownRect = dropdown.getBoundingClientRect();
        const itemRect = item.getBoundingClientRect();
        const dropdownTop = dropdownRect.top;
        const dropdownBottom = dropdownRect.bottom;
        const itemTop = itemRect.top - dropdownTop;
        const itemBottom = itemRect.bottom - dropdownTop;
        const visibleHeight = 150;

        // Scroll the dropdown so the selected item is in view
        if (itemTop < 0) {
          // Item is above the visible area
          dropdown.scrollTop += itemTop - 15; // Adjust scrolling position to show the item
        } else if (itemBottom > visibleHeight) {
          // Item is below the visible area
          dropdown.scrollTop += itemBottom - visibleHeight + 15; // Adjust scrolling position to show the item
        }
      }
    }
  }, [selectedIndex]);

  const handleKeyDown = (event, item) => {
    if (event.key === 'Enter') {
      addItemToBill(item);
    }
  };

  const handlePopupConfirm = () => {
    setShowPopup(false);
    handleSubmit(); // Call handleSubmit when confirmed
  };

  const handlePopupCancel = () => {
    setShowPopup(false); // Close the popup without submitting
  };

  const handleItemTableKeyDown = (e, rowItemTableIndex, colItemTableIndex) => {
    if (!isTableFocused) return; // Only handle arrow keys when table is focused

    switch (e.key) {
      case 'ArrowUp':
        e.preventDefault(); // Prevent quantity field from changing on ArrowUp
        if (rowItemTableIndex > 0 && inputRefs.current[rowItemTableIndex - 1]?.[colItemTableIndex]) {
          inputRefs.current[rowItemTableIndex - 1][colItemTableIndex].focus();
        }
        break;
      case 'ArrowDown':
        e.preventDefault(); // Prevent quantity field from changing on ArrowDown
        if (rowItemTableIndex < selectedItems.length - 1 && inputRefs.current[rowItemTableIndex + 1]?.[colItemTableIndex]) {
          inputRefs.current[rowItemTableIndex + 1][colItemTableIndex].focus();
        }
        break;
      case 'ArrowLeft':
        if (colItemTableIndex > 0 && inputRefs.current[rowItemTableIndex]?.[colItemTableIndex - 1]) {
          inputRefs.current[rowItemTableIndex][colItemTableIndex - 1].focus();
        }
        break;
      case 'ArrowRight':
        if (colItemTableIndex < inputRefs.current[rowItemTableIndex]?.length - 1 && inputRefs.current[rowItemTableIndex]?.[colItemTableIndex + 1]) {
          inputRefs.current[rowItemTableIndex][colItemTableIndex + 1].focus();
        }
        break;
      default:
        break;
    }
  };

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setDropdownOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const addItemToBill = (item) => {
    const existingItemIndex = selectedItems.findIndex(
      (selectedItem) => selectedItem.itemBarcodeID === item.itemBarcodeID
    );

    if (existingItemIndex > -1) {
      const updatedItems = [...selectedItems];
      const existingItem = updatedItems[existingItemIndex];
      existingItem.quantity += 1;
      existingItem.amount = existingItem.quantity * existingItem.wholeSalePrice;
      setSelectedItems(updatedItems);
    } else {
      const newItem = {
        ...item,
        quantity: 1,
        amount: item.wholeSalePrice * 1,
      };
      setSelectedItems([...selectedItems, newItem]);
    }

    setSearchTerm('');
    setSearchResults([]);
    setDropdownOpen(false);

    if (!isBarcodeMode) {
      requestAnimationFrame(() => {
          searchInputRef.current.focus();
      });
    }

    // Scroll to the latest item added
    setTimeout(() => {
      const tableBody = document.querySelector('.items-table tbody');
      if (tableBody) {
        const lastRow = tableBody.lastElementChild;
        if (lastRow) {
          lastRow.scrollIntoView({ behavior: 'smooth', block: 'end' });
        }
      }
    }, 100); // Delay to ensure the item is added to the DOM
  };

  const removeItemFromBill = (index) => {
    const updatedItems = [...selectedItems];
    updatedItems.splice(index, 1);
    setSelectedItems(updatedItems);
  };

  const handleQuantityChange = (index, quantity) => {
    const updatedItems = [...selectedItems];
    updatedItems[index] = {
      ...updatedItems[index],
      quantity: quantity,
      amount: quantity * updatedItems[index].wholeSalePrice,
    };
    setSelectedItems(updatedItems);
  };

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.ctrlKey && event.key === 's') {
        event.preventDefault(); // Prevent the browser's default Save action
        setShowPopup(true); // Show the custom popup
      }
    };

    window.addEventListener('keydown', handleKeyDown);

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, []);




  useEffect(() => {
    if (dropdownOpen && searchResults.length > 0 && dropdownRef.current) {
      dropdownRef.current.firstChild.focus();
    }
  }, [dropdownOpen, searchResults]);

  const calculateTotalAmount = () => {
    let total = 0;
    selectedItems.forEach((item) => {
      total += item.amount;
    });
    return total;
  };

  const calculateTotalQuantity = () => {
    let total_quantity = 0;
    selectedItems.forEach((item) => {
      total_quantity=total_quantity+item.quantity;
    });

    return total_quantity;
  };


  const handleArrowNavigation = (e) => {
    if (e.key === 'ArrowDown') {
      setSelectedIndex((prevIndex) => Math.min(prevIndex + 1, searchResults.length - 1));
      e.preventDefault();
    } else if (e.key === 'ArrowUp') {
      setSelectedIndex((prevIndex) => Math.max(prevIndex - 1, 0));
      e.preventDefault();
    } else if (e.key === 'Enter' && selectedIndex >= 0) {
      addItemToBill(searchResults[selectedIndex]);
      e.preventDefault();
    }
  };

  // ---- Helper: does this item have a valid, non-zero final amount? ----
  const isItemAmountInvalid = (item) => {
    const amt = item.amount;
    return (
      amt === null ||
      amt === undefined ||
      amt === '' ||
      Number.isNaN(Number(amt)) ||
      Number(amt) === 0
    );
  };

 const handleSubmit = async () => {
  if (selectedItems.length === 0) {
    showError('The item list cannot be empty. Please add at least one item.', 'Cannot Generate Bill');
    return;
  }

  if (!customerName || customerName.trim() === "") {
    showError('Company Name is required. Please select a company.', 'Cannot Generate Bill');
    return;
  }

  // ---- NEW: block submission if any item's final price/amount is 0 or null ----
  const invalidItems = selectedItems.filter(isItemAmountInvalid);
  if (invalidItems.length > 0) {
    const labels = invalidItems.map(
      (item, idx) => item.itemName || item.itemCode || item.itemBarcodeID || `Item ${idx + 1}`
    );
    showError(
      'The following item(s) have a missing or ₹0 final price. Please fix the price/discount before billing:',
      'Invalid Item Price',
      labels
    );
    return;
  }

  console.log(customerName);

  const billData = {
    userId: userData.userId,
    companyId: companyId,
    customerName: customerName,
    paymentMode: paymentMode,
    schoolName: schoolName,
    item_count: selectedItems.length,
    bill: selectedItems.map((item) => ({
      itemBarcodeID: item.itemBarcodeID,
      itemType: item.itemType,
      itemColor: item.itemColor,
      itemSize: item.itemSize,
      itemCategory: item.itemCategory,
      sellPrice: item.wholeSalePrice,
      quantity: item.quantity,
      total_amount: item.amount,
    })),
  };

  console.log(billData);

  try {
    setLoading(true);

     const storeConfig = JSON.parse(sessionStorage.getItem("storeConfig") || "{}");
      const printType = (storeConfig.printType || "NORMAL").trim().toUpperCase();


    const isThermal = printType === 'THERMAL';
    const responseType = isThermal ? 'json' : 'arraybuffer';

    const response = await axios.post(
      `${API_BASE_URL}/user/intercompany/billRequest?printType=${printType}`,
      billData,
      { responseType: responseType }
    );

    if (isThermal) {
      // Open thermal print modal
      setBillInfo(response.data);
      setShowPrintModal(true);
    } else {
      // Handle normal PDF print
      const pdfBlob = new Blob([response.data], { type: 'application/pdf' });
      const pdfUrl = URL.createObjectURL(pdfBlob);

      printJS({
        printable: pdfUrl,
        type: "pdf",
      });
    }

    // Reset form
    setSelectedItems([]);
    setCustomerName('');
    setCustomerMobileNo('');
    setPaymentMode('Due');
    setSchoolName('');
    setSelectedCompanyId(null);

  } catch (error) {
    console.error('Error generating bill:', error);
    showError('Error generating bill. Please try again.', 'Bill Generation Failed');
  } finally {
    setLoading(false);
  }
};


  const handlePrint = () => {
    if (pdfModalRef.current) {
      pdfModalRef.current.focus();
      pdfModalRef.current.contentWindow.print();
    }
  };

  const handleClosePdfModal = () => {
    setShowPdfModal(false);
    URL.revokeObjectURL(pdfData); // Clean up the object URL
    setPdfData(null);
  };


const handleNameChange = (e) => {
  const selectedStoreId = e.target.value;
  const selectedStore = storeList.find(store => store.storeId === selectedStoreId);

  if (selectedStore) {
    setCustomerName(selectedStore.storeName);   // store name
    setSelectedCompanyId(selectedStore.storeId); // store ID
  }
};



  const handleMobileNoChange = (e) => {
    setCustomerMobileNo(e.target.value);
  };

  const handlePaymentModeChange = (e) => {
    setPaymentMode(e.target.value);
  };

  useEffect(() => {

    if (searchInputRef.current) {
      searchInputRef.current.focus();  // Automatically focus the input
    }
  }, []);

  const handleAddCustomItem = () => {

    // Create the new item object
    const newItem = {
      itemBarcodeID:customItem.itemBarcodeID,
      itemCode: customItem.itemBarcodeID,
      itemType: customItem.itemType,
      itemColor: customItem.itemColor,
      itemSize: customItem.itemSize,
      itemCategory: customItem.itemCategory,
      itemName: `${customItem.itemCategory} ${customItem.itemType}`,

      quantity: customItem.quantity,
      price:customItem.sellPrice,
      amount:(customItem.quantity)*(customItem.sellPrice),
    };

    // Update the selectedItems state
    setSelectedItems([...selectedItems, newItem]);

    // Close the modal
    setShowCustomItemModal(false);
  };

  const toggleBarcodeMode = (manualMode = null) => {
    setIsBarcodeMode((prevMode) => {
      let newMode;

      if (manualMode !== null) {
        // If a manual mode is provided, use it directly
        newMode = manualMode;
      } else {
        // Default toggle behavior
        const isBarcodeInputFocused = document.activeElement === barcodeInputRef.current;
        const isSearchInputFocused = document.activeElement === searchInputRef.current;

        if (isBarcodeInputFocused) {
          newMode = false; // Switch to search mode
        } else if (isSearchInputFocused) {
          newMode = true; // Switch to barcode mode
        } else {
          newMode = !prevMode;
        }
      }

      setTimeout(() => {
        if (newMode) {
          barcodeInputRef.current.focus();
        } else {
          searchInputRef.current.focus();
        }
      }, 0);

      return newMode;
    });
  };


  const handleArrowKeyCustomerDetail = (e, fieldName) => {
    const fields = ['customerName', 'customerMobileNo', 'schoolName'];
    const currentIndex = fields.indexOf(fieldName);

    if (e.key === 'ArrowLeft') {
      // Move to the previous field if it exists
      if (currentIndex > 0) {
        document.querySelector(`[name=${fields[currentIndex - 1]}]`).focus();
      }
    } else if (e.key === 'ArrowRight') {
      // Move to the next field if it exists
      if (currentIndex < fields.length - 1) {
        document.querySelector(`[name=${fields[currentIndex + 1]}]`).focus();
      }
    }
  };

  useEffect(() => {
    if (showCustomItemModal) {
      setCustomItem({
        itemBarcodeID: 'SG9999999',
        itemType: '',
        itemColor: '',
        itemSize: '',
        itemCategory: '',
        sellPrice: 0,
        quantity: 1,
        amount: 0,
      });
    }
  }, [showCustomItemModal]);

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.ctrlKey && event.key === 'c') {
        setShowCustomItemModal(true);  // Open the modal
        setSomeState(true);  // Simultaneously set a variable or state
      }
    };

    window.addEventListener('keydown', handleKeyDown);

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [someState]); // Dependency array with `someState`

  // Effect to listen for Shift key press and toggle mode
  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === 'Shift') {
        const currentTime = new Date().getTime(); // Get current time

        // Check if Shift was pressed twice within 500ms (or adjust as needed)
        if (shiftPressTime && currentTime - shiftPressTime < 500) {
          toggleBarcodeMode(); // Change mode if Shift is pressed twice quickly
          setShiftPressTime(null); // Reset the time
        } else {
          setShiftPressTime(currentTime); // Store the time of the first Shift press
        }
      }
    };

    window.addEventListener('keydown', handleKeyDown);

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [shiftPressTime]); // Track shiftPressTime changes


return (
  <div className={styles.newBillContainer}>
    {loading && (
      <div className={styles.loadingOverlay}>
        <div className={styles.spinner}></div>
        <p>Generating bill...</p>
      </div>
    )}

    {/* Header Section */}
    <div className={styles.billingContainer}>
      <div className={styles.modeToggle}>
        <button
          className={isBarcodeMode ? styles.barcodeMode : styles.searchMode}
          onClick={() => toggleBarcodeMode(!isBarcodeMode)}
        >
          {isBarcodeMode ? "Barcode Mode" : "Search Mode"}
        </button>
      </div>

      <div className={styles.billingHead}>
        <h2>Inter Company Transfer</h2>
      </div>

      <div className={styles.barcodeInput}>
        <input
          type="text"
          placeholder="Scan or enter barcode and press Enter"
          value={barcode}
          onChange={(e) => setBarcode(e.target.value)}
          ref={barcodeInputRef}
          onFocus={() => setIsBarcodeMode(true)}
        />
      </div>
    </div>

    {/* Search Bar Section */}
    <div className={styles.searchBarContainer}>
      <div className={styles.searchBar} tabIndex="0">
        <input
          type="text"
          placeholder="Search by item code"
          value={searchTerm}
          ref={searchInputRef}
          onChange={(e) => setSearchTerm(e.target.value)}
          onFocus={(e) => {
            setSearchTerm(e.target.value);
            setDropdownOpen(true);
            toggleBarcodeMode(false);
          }}
          onKeyDown={handleArrowNavigation}
        />
        {dropdownOpen && (
          <div className={styles.dropdown} ref={dropdownRef}>
            <table>
              <thead>
                <tr>
                  <th>Item Code</th>
                  <th>Item Name</th>
                  <th>Type</th>
                  <th>Color</th>
                  <th>Size</th>
                  <th>Price</th>
                </tr>
              </thead>
              <tbody>
                {searchResults.map((item, index) => (
                  <tr
                    key={item.itemBarcodeID}
                    onClick={() => addItemToBill(item)}
                    onKeyDown={(e) => handleKeyDown(e, item)}
                    tabIndex="0"
                    style={{
                      backgroundColor: index === selectedIndex ? 'lightblue' : 'transparent'
                    }}
                  >
                    <td>{item.itemCode}</td>
                    <td>{item.itemName}</td>
                    <td>{item.itemType}</td>
                    <td>{item.itemColor}</td>
                    <td>{item.itemSize}</td>
                    <td>{item.wholeSalePrice}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>

    {/* Company Details Section */}
    <div className={styles.intercompanyCustomerDetails}>
      <div className={styles.intercompanyCustomerDetailsBox}>
        <label>
          Company Name:
          <select
            name="companyId"
            value={companyId ?? ""}
            onChange={handleNameChange}
            onKeyDown={(e) => handleArrowKeyCustomerDetail(e, 'customerName')}
            required
          >
            <option value="">Select Company</option>
            {storeList.map((store) => (
              <option key={store.storeId} value={store.storeId}>
                {store.storeName} - {store.address}
              </option>
            ))}
          </select>
        </label>
      </div>
    </div>

    {/* Items Table */}
    <div
      className={styles.itemsTableContainer}
      onFocus={() => setIsTableFocused(true)}
      onBlur={() => setIsTableFocused(false)}
      tabIndex={0}
    >
      <div className={styles.itemsTable}>
        <table>
          <thead>
            <tr>
              <th>Item Code</th>
              <th>Item Name</th>
              <th>Color</th>
              <th>Size</th>
              <th>Discount</th>
              <th>Price</th>
              <th>Quantity</th>
              <th>Amount</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {selectedItems.map((item, rowItemTableIndex) => {
              const invalid = isItemAmountInvalid(item);
              return (
              <tr
                key={rowItemTableIndex}
                className={invalid ? styles.invalidRow : undefined}
              >
                <td>{item.itemCode}</td>
                <td>{item.itemName}</td>
                <td>{item.itemColor}</td>
                <td>{item.itemSize}</td>

                <td>
                  <input
                    type="number"
                    value={item.discountAmount || ''}
                    onChange={(e) => handleDiscountChange(rowItemTableIndex, parseFloat(e.target.value) || 0)}
                    disabled={item.discount !== 'Yes'}
                  />
                </td>
                <td>{item.wholeSalePrice}</td>

                <td className={styles.itemTableQuantityTd}>
                  <div className={styles.itemTableQuantityContainer}>
                    {/* Decrease Button */}
                    <button
                      type="button"
                      className={`${styles.itemTableQuantityBtn} ${styles.itemTableQuantityBtnDecrease}`}
                      onClick={() => {
                        let currentValue = parseInt(inputRefs.current[rowItemTableIndex][4].value, 10) || 0;
                        let newValue = Math.max(1, currentValue - 1);
                        handleQuantityChange(rowItemTableIndex, newValue);
                      }}
                    >
                      -
                    </button>

                    {/* Quantity Input */}
                    <input
                      type="number"
                      value={item.quantity}
                      ref={(el) => {
                        if (!inputRefs.current[rowItemTableIndex]) inputRefs.current[rowItemTableIndex] = [];
                        inputRefs.current[rowItemTableIndex][4] = el;
                      }}
                      onChange={(e) =>
                        handleQuantityChange(rowItemTableIndex, parseInt(e.target.value, 10))
                      }
                      onKeyDown={(e) => {
                        handleItemTableKeyDown(e, rowItemTableIndex, 4);
                        if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
                          e.preventDefault();
                        }
                      }}
                      min="1"
                      className={styles.itemTableQuantityInput}
                    />

                    {/* Increase Button */}
                    <button
                      type="button"
                      className={`${styles.itemTableQuantityBtn} ${styles.itemTableQuantityBtnIncrease}`}
                      onClick={() => {
                        let currentValue = parseInt(inputRefs.current[rowItemTableIndex][4].value, 10) || 0;
                        let newValue = currentValue + 1;
                        handleQuantityChange(rowItemTableIndex, newValue);
                      }}
                    >
                      +
                    </button>
                  </div>
                </td>

                <td className={invalid ? styles.invalidAmount : undefined}>
                  {(item.amount ?? 0).toFixed ? item.amount.toFixed(2) : item.amount}
                </td>
                <td>
                  <button onClick={() => removeItemFromBill(rowItemTableIndex)}>Remove</button>
                </td>
              </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>

    {/* Summary Section */}
    <div className={styles.summary}>
      <div className={styles.customBtn}>
        <button onClick={() => setShowCustomItemModal(true)}>Custom Item</button>
      </div>
      <div className={styles.itemSummary}>
        <h3>Total Amount: {calculateTotalAmount().toFixed(2)} Rs</h3>
        <h4>Item Count: {selectedItems.length}</h4>
        <h4>Total Quantity: {calculateTotalQuantity()}</h4>
      </div>
      <div className={styles.paymentSection}>
        <div className={styles.paymentMode}>
          <label>
            Payment Mode:
            <select value={paymentMode} onChange={handlePaymentModeChange}>
              <option value="Cash">Cash</option>
              <option value="Upi">UPI</option>
              <option value="Card">Card</option>
              <option value="Due">Due</option>
            </select>
          </label>
          <button id={styles.submitBtn} onClick={handleSubmit}>Bill</button>
        </div>
      </div>
    </div>

    {/* Bill Popup */}
    {showPopup && (
      <BillPopup
        onConfirm={handlePopupConfirm}
        onCancel={handlePopupCancel}
      />
    )}

    {/* PDF Modal */}
    <Modal show={showPdfModal} onHide={handleClosePdfModal} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Bill PDF</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {pdfData && (
          <iframe
            ref={pdfModalRef}
            src={pdfData}
            width="100%"
            height="500px"
            title="Bill PDF"
          />
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClosePdfModal}>
          Close
        </Button>
        <Button variant="primary" onClick={handlePrint}>
          Print
        </Button>
      </Modal.Footer>
    </Modal>

{showCustomItemModal && (
  <div className={styles.modalOverlay} onClick={() => setShowCustomItemModal(false)}>
    <div className={styles.modalContainer} onClick={(e) => e.stopPropagation()}>
      <div className={styles.modalHeader}>
        <h2 className={styles.modalTitle}>Add Custom Item</h2>
        <button
          className={styles.closeButton}
          onClick={() => setShowCustomItemModal(false)}
          aria-label="Close"
        >
          ×
        </button>
      </div>

      <div className={styles.modalBody}>
        <form>
          <div className={styles.formGroup}>
            <label>Item Barcode ID:</label>
            <input
              type="text"
              name="itemBarcodeID"
              value={customItem.itemBarcodeID}
              onChange={handleCustomItemChange}
              readOnly
            />
          </div>

          <div className={styles.formGroup}>
            <label>Item Type:</label>
            <input
              type="text"
              name="itemType"
              value={customItem.itemType}
              onChange={handleCustomItemChange}
              placeholder="Enter item type"
            />
          </div>

          <div className={styles.formGroup}>
            <label>Item Color:</label>
            <input
              type="text"
              name="itemColor"
              value={customItem.itemColor}
              onChange={handleCustomItemChange}
              placeholder="Enter color"
            />
          </div>

          <div className={styles.formGroup}>
            <label>Item Size:</label>
            <input
              type="text"
              name="itemSize"
              value={customItem.itemSize}
              onChange={handleCustomItemChange}
              placeholder="Enter size"
            />
          </div>

          <div className={styles.formGroup}>
            <label>Item Category:</label>
            <input
              type="text"
              name="itemCategory"
              value={customItem.itemCategory}
              onChange={handleCustomItemChange}
              placeholder="Enter category"
            />
          </div>

          <div className={styles.formGroup}>
            <label>Price:</label>
            <input
              type="number"
              name="sellPrice"
              value={customItem.sellPrice}
              onChange={handleCustomItemChange}
              placeholder="0.00"
              step="0.01"
            />
          </div>

          <div className={styles.formGroup}>
            <label>Quantity:</label>
            <input
              type="number"
              name="quantity"
              value={customItem.quantity}
              onChange={handleCustomItemChange}
              min="1"
              placeholder="1"
            />
          </div>
        </form>
      </div>

      <div className={styles.modalFooter}>
        <button
          className={styles.secondaryButton}
          onClick={() => setShowCustomItemModal(false)}
        >
          Close
        </button>
        <button
          className={styles.primaryButton}
          onClick={handleAddCustomItem}
        >
          Add Item
        </button>
      </div>
    </div>
  </div>
)}

  <PrintBillModal
    isOpen={showPrintModal}
    onClose={() => setShowPrintModal(false)}
    billInfo={billInfo}
  />

{/* Error Modal - restyled to match Recent Bills modal */}
  {showErrorModal && (
    <div className={styles.errorModalOverlay} onClick={closeErrorModal}>
      <div className={styles.errorModalCard} onClick={(e) => e.stopPropagation()}>
        <div className={styles.errorModalTopBar}>
          <h2 className={styles.errorModalHeading}>{errorModalTitle}</h2>
          <button className={styles.errorCloseBtn} onClick={closeErrorModal}>
            Close
          </button>
        </div>

        <div className={styles.errorModalContent}>
          <p className={styles.errorModalMessage}>{errorModalMessage}</p>

          {errorModalItems.length > 0 && (
            <div className={styles.errorItemsTable}>
              <div className={styles.errorItemsTableHeader}>
                <span>Item Code</span>
                <span>Issue</span>
              </div>
              <div className={styles.errorItemsTableBody}>
                {errorModalItems.map((label, idx) => (
                  <div className={styles.errorItemsTableRow} key={idx}>
                    <span className={styles.errorItemCode}>{label}</span>
                    <span className={styles.errorItemIssue}>Price / Amount is ₹0 or missing</span>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  )}
  
    </div>
);

};


export default InterCompanyTranfer;